
































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { rejectLogin, validations, userInfo, getOperId } from '@/api/api.config'
import { isPhoneNumber } from '@/utils/utils'
@Component
export default class login extends Vue {
  checked = false
  isShow = false
  phone = ''
  code = ''
  openId: any = ''
  count: any = null
  time: any = null
  text = '获取验证码'
  changes(e: any) {
    if (e.target.value) {
      this.isShow = true
    }
  }
  deletes() {
    this.isShow = false
    this.phone = ''
  }
  addBtnPasword(): any {
    this.setInterValFunc()
  }
  setInterValFunc() {
    let Time_out = 60
    if (this.time) return
    if (isPhoneNumber(this.phone)) {
      this.count = Time_out
      // 请求接口
      validations(this.phone)
      this.time = setInterval(() => {
        if (this.count > 0 && this.count <= Time_out) {
          let timeouts = this.count--
          this.text = `重新获取${timeouts}s`
        } else {
          clearInterval(this.time)
          this.time = null
          this.text = '获取验证码'
        }
      }, 1000)
    } else {
      this.$toast.fail('手机号错误')
    }
  }
  logins() {
    if (!isPhoneNumber(this.phone)) {
      this.$toast.fail('手机号错误')
      return
    }
    if (!this.code.trim()) {
      this.$toast.fail('请输入密码')
      return
    }
    if (!this.checked) {
      this.$toast.fail('请勾选我已阅读并同意')
      return
    }
    let { phone, code, openId } = this
    rejectLogin({
      phone: phone,
      code: code,
      openId: localStorage.getItem('openId'),
    })
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem('user-token', `Bearer ${res.data.access_token}`)
          this.userInfos()
          this.$toast.success('登录成功')
          this.$router.push({
            path: '/homes',
          })
        } else if (res.status === 400) {
          return this.$toast.fail('验证码错误')
        }
      })
      .catch((err) => {
        this.$toast.fail('验证码错误')
      })
  }
  // 用户信息
  userInfos() {
    userInfo().then((res) => {
      if (res.status === 200) {
      }
    })
  }
  tolist(id: any) {
    this.$router.push({
      path: '/protocol',
      query: { id: id },
    })
  }

  mounted() {
    this.openId = localStorage.getItem('openId')
  }
}
